import moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private statusSubject = new BehaviorSubject<boolean>(false);
  // Keep in mind that the spinner can be started several times
  // so we need a counter in order to track the very first time the spinner is started
  // and when it's fully stopped
  private counter = 0;
  /**
   * Number of milliseconds a session keeps alive
   * A session is a pull of http queries triggered by a page / feature from angular SPA
   * That way, it's possible, for the backend, to aggregate all queries necessary to build a page
   */
  sessionTTL: number = 300;

  private session: {
    finishedAt?: moment.Moment;
    id?: string;
  } = {};

  getState(): Observable<boolean> {
    return this.statusSubject.asObservable();
  }

  /**
   * Only the SpinnerLauncherService interceptor can use this method
   */
  start() {
    if (this.counter === 0) {
      this.sessionStart();
    }
    this.counter++;
  }

  /**
   * Only the SpinnerLauncherService interceptor can use this method
   */
  stop() {
    this.counter--;
    if (this.counter === 0) {
      this.sessionStop();
    }
  }

  sessionId() {
    return this.session.id;
  }

  getRequestId(sessionId: string, counter: number) {
    return `${sessionId}.${counter}`;
  }

  resetSessionId() {
    if (this.session.id && !this.session.finishedAt) {
      this.session.id = uuid();
    } else {
      this.session = {};
    }
  }

  private sessionStart() {
    this.statusSubject.next(true);

    if (!this.session.id || moment().valueOf() - this.session.finishedAt.valueOf() > this.sessionTTL) {
      this.session.id = uuid();
    }
    this.session.finishedAt = undefined;
  }

  private sessionStop() {
    this.statusSubject.next(false);

    this.session.finishedAt = moment();
  }
}
